import {CorrectAnswer} from './correctAnswer';
import {Words} from './words';

export class Question {
    _id:string;
    createdAt:string;
    status:string;
    summary:string;
    title:string;
    description: String;
    questionNumber: any;
    questionType: string = "0";
    selectedAnswerid:string;
    isCorrect: boolean;
    subQuestions: CorrectAnswer;
    isSkiped: boolean;
    isDone: boolean = false;
    isGroup: boolean;
    isMain: boolean;
    parentQuestionObj : Question;
    selectedAnswerIndex: string;
    userAnswerIndex:string;
    isRoleback: boolean;
    answers: any;
    subpart: any;
    time: string;
    parentObj:Question;
    subCategory: subCategory;
    category : string;
    correctAnswer: CorrectAnswer;
    answerIds:Array<Words>;
    version : number ;
    count : number;
    partid : any;
    words : Array<Words>;
    reviwDescription : string ;
    isUnderline: boolean = false;
    isCircle: boolean = false;
    userOptionUnderline: boolean = false;
    userOptionCircle: boolean = false;
    answerType: String;
    explanation: string = "";
    descriptionComponentType:string;
    answerComponentType:string
    questionLabel:any;
    questionNumberLabel: String;
  
    userAnswerType: string;
    images: string;

    
    constructor(values: Object = {}) {
        Object.assign(this, values);
        // values['questionType'] == 'gr_type_2' ? this.questionType = 'gr_type_6' : '' ;
        // console.info(this);
    }

    isAnswerCorrectMethod(){
        return this.userOptionCircle == this.isCircle || this.userOptionUnderline == this.isUnderline;
    }
}

export class subCategory {
    category: string;
    _id: string;
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/model/question.ts